import BuySuccessWidget from "@/widgets/BuySuccess/BuySuccessWidget.jsx";

export default function  BuySuccessPage () {
    return <BuySuccessWidget/>
}